import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Grid, Paper, Typography, Box } from '@mui/material';

import PhoneListingCard from 'app/components/PhoneListingCard';
import IconOffer from 'app/components/customSvgs/IconOffer';
import { dateStamp } from 'app/helpers/timestampHelpers';
import { useUseUserOffersMutation } from 'app/features/account/api/accountApi';

const SeekerUserOfferCard = ({ offer }) => {
  const [redeemed, setRedeemed] = useState(false);

  const filteredListing = {
    id: offer.id,
    login: 'Niteflirt',
    title: 'Get $10 by converting phone-registered account',
    photo_url: '/plus_frontend/assets/photo-nf.png',
    full_category: '',
    headingSource: 'category',
  };

  const [useUserOffers] = useUseUserOffersMutation();
  const handleRedeem = () => {
    useUserOffers(offer.offer_hash);
    setRedeemed(true);
  };

  // hide ourself once the offer is redeemed
  if (redeemed) return null;

  return (
    <Paper sx={{ pb: 0, mb: 1.5, backgroundColor: '#eee' }} elevation={0}>
      <Box sx={{ maxWidth: 330, mx: 'auto', textAlign: 'center' }}>
        <Grid
          container
          alignItems="center"
          justifyContent="flex-start"
          sx={{
            color: 'var(--color_gray_three)',
            p: 0.5,
            backgroundColor: '#fff',
            border: '1px dotted #ef8d34',
          }}
        >
          <Grid item sx={{ ml: 1, mr: 1.5 }}>
            <IconOffer htmlColor="#ef8d34" sx={{ fontSize: 28 }} />
          </Grid>
          <Grid item sx={{ textAlign: 'left' }}>
            <Typography variant="subtitle1" sx={{ color: '#ef8d34', mb: -0.5 }}>
              Web Registration Offer - $10.00
            </Typography>
            <Typography variant="body3" sx={{ color: '#999' }}>
              Expires in&nbsp;
              {offer.days_from_now}
              &nbsp;days (
              {dateStamp(offer.expires_at)}
              )
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Box sx={{ position: 'relative', display: 'block', width: 'fit-content' }}>
            <Box sx={{ textAlign: 'left' }}>
              <PhoneListingCard listing={filteredListing} onDetailsClick={() => {}} />
            </Box>

            <Box
              sx={{
                position: 'absolute',
                bottom: '30px',
                left: '240px',
                transform: 'translateX(-50%)',
                zIndex: 10,
                backgroundColor: 'white',
                height: '50px',
                width: '170px',
                paddingTop: '16px',
              }}
            >
              <Button
                onClick={handleRedeem}
                variant="contained"
                size="small"
                color="secondary"
                sx={{ minWidth: '138px', fontSize: '0.938em' }}
              >
                Redeem
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

SeekerUserOfferCard.propTypes = {
  offer: PropTypes.object.isRequired,
};

export default SeekerUserOfferCard;
